<template>
  <div>
    <transition name="modal">
      <div class="modal-mask eh-popup-overlay">
        <div class="modal-wrapper">
          <div class="modal-container eh-popup-panel">

            <h3 class="modal-title">Where do you want to put the extraction?</h3>


            <div class="modal-body">
              <slot name="body">
                <form>
                  <div class="form-check">
                    <input type="radio" value="appendToLastPage" id="appendToLastPage" v-model="checked">
                    <label class="form-check-label" for="appendToLastPage">
                      Append to last extraction
                    </label>
                  </div>

                  <div class="form-check">
                    <input type="radio" value="insertBeforeFirstPage" id="insertBeforeFirstPage" v-model="checked">
                    <label class="form-check-label" for="insertBeforeFirstPage">
                      Insert before first extraction
                    </label>
                  </div>

                  <div class="form-check">
                    <input type="radio" value="insertTo" id="insertTo" v-model="checked">
                    <label class="form-check-label" for="insertTo">
                      Insert to
                    </label>
                    <input type="text"
                           @focus="autoSelect"
                           v-model="whereToInsert" required/>
                  </div>
                </form>

              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button btn" @click="$emit('close', checked, whereToInsert)">
                  Confirm
                </button>
              </slot>
            </div>

          </div>
        </div>
      </div>
    </transition>

  </div>


</template>

<script>
  export default {
    name: "PdfModalInsert",
    props: {
      indexOfHighlighted: Number,
    },
    data() {
      return {
        showInsertModal: false,
        checked: 'appendToLastPage',
        whereToInsert: this.indexOfHighlighted,
      }
    },
    methods: {
      // check the corresponding radio button if input field gets focus
      autoSelect() {
        this.checked = 'insertTo';
      }
    }
  }
</script>

<style scoped lang="scss">
  .modal-mask {
    /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
    width: 400px;
    margin: 0 auto;
    padding: 20px 10px;
    transition: all .3s ease;
  }

  .modal-title {
    font-size: 16px;
    text-align: center;
  }

  .modal-body {
    margin: 10px 0;
    font-size: 1.0rem;
  }

  .modal-footer {
    padding: 10px;
  }

  .modal-default-button {
    float: right;
    background-color: #2196F3;
    color: #ffffff;
    padding: 5px 10px;
    font-size: 14px;

    &:hover {
      background-color: #0060ff;
    }
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .form-check {
    display: flex;
    flex-direction: row;
    margin-bottom: 5px;
    input[type=text] {
      width: 80px;
      margin-left: 10px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
      margin-left: 5px;
    }
    input[type=radio] {
      height: 10px;
    }
  }

  @media only screen and (max-width: 768px) {
    .modal-container {
      width: 100%;
    }
  }
</style>